import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Paper as y, Typography as e, IconButton as f } from "@mui/material";
import i from "@mui/material/Grid";
import { prettyDate as h } from "../../helpers/dates.js";
import { l as D, m as T } from "../../index-DNTqwtVt.js";
const j = ({ taskandoutcomes: a, showExtensionLink: t, onRequestExtensionClick: o, extensionRequest: s, isPreview: c = !1 }) => {
  if (!a.task)
    return null;
  const { ClassName: u, Status: l, TeacherName: v, SetDate: d, DueDate: p, Description: m } = a.task, x = s ? s.Approved !== null ? s.Approved ? "Extension approved" : "Extension denied" : "Extension requested" : null;
  return /* @__PURE__ */ n(y, { elevation: 1, sx: { padding: 2 }, children: /* @__PURE__ */ r(i, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ r(i, { size: { xs: 6, sm: 4 }, children: [
      /* @__PURE__ */ n(e, { variant: "caption", children: "Class" }),
      /* @__PURE__ */ n(e, { variant: "body2", children: u })
    ] }),
    l && /* @__PURE__ */ r(i, { size: { xs: 6, sm: 4 }, children: [
      /* @__PURE__ */ n(e, { variant: "caption", children: "Status" }),
      /* @__PURE__ */ n(e, { variant: "body2", children: l })
    ] }),
    /* @__PURE__ */ r(i, { size: { xs: 6, sm: 4 }, children: [
      /* @__PURE__ */ n(e, { variant: "caption", children: "Teacher" }),
      /* @__PURE__ */ n(e, { variant: "body2", children: v })
    ] }),
    /* @__PURE__ */ r(i, { size: { xs: 6, sm: 4 }, children: [
      /* @__PURE__ */ n(e, { variant: "caption", children: "Set On" }),
      /* @__PURE__ */ n(e, { variant: "body2", children: d && h(d) })
    ] }),
    /* @__PURE__ */ r(i, { size: { xs: 6, sm: 4 }, children: [
      /* @__PURE__ */ n(e, { variant: "caption", children: "Due On" }),
      /* @__PURE__ */ n(e, { variant: "body2", children: p && h(p) }),
      !c && t && o && /* @__PURE__ */ r(
        f,
        {
          size: "small",
          onClick: o,
          "aria-label": "Request extension",
          sx: { color: "primary.main" },
          children: [
            /* @__PURE__ */ n(D, { iconType: T.Calendar, fontSize: "small" }),
            /* @__PURE__ */ n(e, { variant: "body2", children: x || "Extension" })
          ]
        }
      )
    ] }),
    !c && m && /* @__PURE__ */ r(i, { size: { xs: 12 }, children: [
      /* @__PURE__ */ n(e, { variant: "caption", children: "Description" }),
      /* @__PURE__ */ n(e, { variant: "body2", children: b(m) })
    ] })
  ] }) });
}, b = (a) => {
  const t = document.createElement("div");
  return t.innerHTML = a, t.textContent || t.innerText || "";
};
export {
  j as TaskDetails
};
//# sourceMappingURL=TaskDetails.js.map
